import styled from 'styled-components'

export default styled.input`
	${props => (props.type === 'file' ? 'display: none;' : '')};
`



// WEBPACK FOOTER //
// ./src/primitives/Input.js